import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Import pages
import Main from "./pages/Main/Main";
import Home from "./pages/Home/Home";
import Services from "./pages/Services/Services";
import Packages from "./pages/Packages/Packages";
import Cart from "./pages/Cart/Cart";
import Orders from "./pages/Orders/Orders";
import Notifications from "./pages/Notifications/Notifications";
import ContactUs from "./pages/ContactUs/ContactUs";
// import Favorites from "./pages/Favorites/Favorites";
import Profile from "./pages/Profile/Profile";
import UserSubscriptions from "./pages/UserSubscriptions/UserSubscriptions";
import Address from "./pages/Address/Address";
import ProtectedRoute from "./components/ProtectedRoute";
import { LanguageProvider } from "./context/LanguageContext";
import { AuthProvider } from "./context/AuthContext";
import { WebSocketProvider } from "./context/WebSocketContext";
import { CartProvider } from "./context/CartContext";
import Success from "./pages/Success/Success";
import Failed from "./pages/Failed/Failed";
import Terms from "./pages/Terms/Terms";
import OAuthCallbackHandler from "./utils/OAuthCallbackHandler";


// Layout wrapper with OAuthCallbackHandler
const LayoutWithOAuth = () => {
  return (
    <>
      <OAuthCallbackHandler />
      <Main />
    </>
  );
};

// App Root Component
const AppRoot = () => {
  return (
    <>
      <ToastContainer
        position="top-center"
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={document.documentElement.dir === "rtl"}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <RouterProvider router={router} />
    </>
  );
};

// Router configuration with Auth, WebSocket, Language, and Cart context
const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <LanguageProvider>
        <AuthProvider>
          <WebSocketProvider>
            <CartProvider>
              <LayoutWithOAuth />
            </CartProvider>
          </WebSocketProvider>
        </AuthProvider>
      </LanguageProvider>
    ),
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/services",
        element: (
          <ProtectedRoute>
            <Services />
          </ProtectedRoute>
        ),
      },
      {
        path: "/packages",
        element: <Packages />,
      },
      {
        path: "/contact",
        element: <ContactUs />,
      },
      {
        path: "/terms",
        element: <Terms />,
      },
      // Protected routes (authentication required)
      {
        path: "/cart",
        element: (
          <ProtectedRoute>
            <Cart />
          </ProtectedRoute>
        ),
      },
      {
        path: "/orders",
        element: (
          <ProtectedRoute>
            <Orders />
          </ProtectedRoute>
        ),
      },
      {
        path: "/notifications",
        element: (
          <ProtectedRoute>
            <Notifications />
          </ProtectedRoute>
        ),
      },
      {
        path: "/profile",
        element: (
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        ),
      },
      {
        path: "/success",
        element: (
          <ProtectedRoute>
            <Success />
          </ProtectedRoute>
        ),
      },
      {
        path: "/failure",
        element: (
          <ProtectedRoute>
            <Failed />
          </ProtectedRoute>
        ),
      },
      {
        path: "/subscriptions",
        element: (
          <ProtectedRoute>
            <UserSubscriptions />
          </ProtectedRoute>
        ),
      },
      {
        path: "/address",
        element: (
          <ProtectedRoute>
            <Address />
          </ProtectedRoute>
        ),
      },
    ],
  },
]);

function App() {
  return <AppRoot />;
}

export default App;